module.exports = __webpack_public_path__ + "img/prize-05.7d03f5e6.png";